var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            @font-face{font-family:Monorale;font-weight:400;font-style:normal;src:url(/fonts/Monorale-Regular.woff) format(&apos;woff&apos;);font-display:fallback}@font-face{font-family:Monorale;font-weight:500;font-style:normal;src:url(/fonts/Monorale-Medium.woff) format(&apos;woff&apos;);font-display:fallback}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#93A5B2",
    fillRule: "evenodd",
    fontFamily: "Monorale"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "PeopleTracker")), /*#__PURE__*/React.createElement("text", {
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33
  }, "AnalyzerUI")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logoName.d4b5cb18.svg";
export { ForwardRef as ReactComponent };